import type { AllRouteEndpoints } from "../routeTypes";

export const customObjectsCustomObjectTypeRelationships = "/data_objects/data_object_type_relationships";

export const customObjectsCustomObjectTypeRelationshipsCacheKeys: AllRouteEndpoints[] = [
  "/data_objects/data_object_type_relationships",
];
